function showToasts(vm, message, variant) {
    vm.$root.$bvToast.toast(message, {
        title: variant,
        variant: variant,
        headerClass: 'toast__header',
        bodyClass: 'font-green-16',
        toaster: 'b-toaster-top-center',
        solid: true,
    })
}

export default { showToasts }